import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = () => {
  const { logout } = useAuth0();
  let audio = new Audio(`${process.env.PUBLIC_URL}/Mario (Bye Bye).mp3`)

  const out = () => {
    audio.play()
    audio.onended = () => {
      logout({ logoutParams: { returnTo: window.location.origin }});
    };
  }
  return (
    <div className="flex flex_column flex_center">
        <button className="button-large " onClick={() => out() }>
            Log Out
        </button>
    </div>

  );
};

export default LogoutButton;